import Info from './info';

export * from './info';
export default Info;
